import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';

const EditMealDialog = ({ isOpen, onClose, meal, mealType, onSave }) => {
  const [mealName, setMealName] = useState(meal || '');
  const [calories, setCalories] = useState(0);
  const [protein, setProtein] = useState(0);

  const handleSave = () => {
    onSave({
      meal: mealName,
      calories: parseInt(calories) || 0,
      protein: parseInt(protein) || 0
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar {mealType}</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div>
            <Label>Nome da Refeição</Label>
            <Input
              value={mealName}
              onChange={(e) => setMealName(e.target.value)}
              placeholder="Ex: Omelete com queijo"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Calorias (kcal)</Label>
              <Input
                type="number"
                value={calories}
                onChange={(e) => setCalories(e.target.value)}
                placeholder="350"
              />
            </div>
            
            <div>
              <Label>Proteínas (g)</Label>
              <Input
                type="number"
                value={protein}
                onChange={(e) => setProtein(e.target.value)}
                placeholder="15"
              />
            </div>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSave} className="bg-orange-600 hover:bg-orange-700">Salvar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditMealDialog;